import Text from '@deprecated-ui/common/Text';
import StreamCompose from 'global/StreamCompose';
import { useDispatch, useSelector } from 'react-redux';
import { parseStreamPostContent } from 'utils/stream';
import {
  effects as streamEffects,
  selectors as streamSelectors,
} from 'lib/entities/stream';
import { COMPOSE_MODE } from 'global/StreamCompose/constants';
import { useEffect } from 'react';
import { mainProfileEvents } from 'features/user/analytics/ProfileAnalytics';
import { handleErrorPostStream } from 'utils/streamError';
import { Modal } from './styled';

interface ModalIdeaProp {
  visible: boolean;
  username: string;
  onCancel: () => void;
  [key: string]: any;
}

function ModalShareIdea({
  visible,
  username,
  onCancel,
  ...props
}: ModalIdeaProp) {
  const dispatch = useDispatch();

  const {
    composeStream: { isLoading },
  } = useSelector(streamSelectors);

  const initialValues = parseStreamPostContent({
    content_original: `@${username} `,
  });

  const handleSharePost = async (val) => {
    // @ts-ignore
    const compose = await dispatch(streamEffects.postStream(val));
    // @ts-ignore
    const { error } = compose.payload;

    handleErrorPostStream(error);

    if (!error) {
      onCancel();
    }

    return error;
  };

  useEffect(() => {
    if (visible) mainProfileEvents.onComposePostViewed();
  }, [visible]);

  return (
    <Modal
      {...props}
      visible={visible}
      // @ts-expect-error
      noBorder
      onCancel={onCancel}
      title={
        <Text size="18px" height="44px" align="center" family="bold">
          Share an Idea
        </Text>
      }
      footer={null}
      centered
      bodyStyle={{
        padding: 0,
      }}
    >
      <StreamCompose
        mode={COMPOSE_MODE.SHARE}
        initialValues={initialValues}
        isLoading={isLoading}
        onSubmit={handleSharePost}
        onCancel={onCancel}
      />
    </Modal>
  );
}

export default ModalShareIdea;
